import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { isValidEmail } from '@/utils/validate';
import LangSelect from '@/components/LangSelect/index.vue';
import { sendRecoveryMail } from '@/api/queue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.validateUsername = (rule, value, callback) => {
      if (!isValidEmail(value)) {
        callback(new Error('Please enter valid email'));
      } else {
        callback();
      }
    };
    this.recoveryForm = {
      email: ''
    };
    this.recoveryRules = {
      email: [{
        validator: this.validateUsername,
        trigger: 'blur'
      }]
    };
    this.passwordType = 'password';
    this.loading = false;
    this.showDialog = false;
    this.otherQuery = {};
  }
  // @Watch('$route', { immediate: true })
  // private onRouteChange(route: Route) {
  //   // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
  //   // See https://github.com/vuejs/vue-router/pull/2050 for details
  //   const query = route.query as Dictionary<string>
  //   if (query) {
  //     this.redirect = query.redirect
  //     this.otherQuery = this.getOtherQuery(query)
  //   }
  // }
  // mounted() {
  //   if (this.recoveryForm.email === '') {
  //     (this.$refs.email as Input).focus()
  //   }
  // }
  //   private showPwd() {
  //     if (this.passwordType === 'password') {
  //       this.passwordType = ''
  //     } else {
  //       this.passwordType = 'password'
  //     }
  //     this.$nextTick(() => {
  //       (this.$refs.password as Input).focus()
  //     })
  //   }
  handleLogin() {
    this.$refs.recoveryForm.validate(async valid => {
      if (valid) {
        this.loading = true;
        try {
          await sendRecoveryMail(this.recoveryForm);
          this.$notify({
            title: 'Success',
            message: 'Recovery mail send',
            type: 'success',
            duration: 2000
          });
          this.$router.push({
            path: '/login'
            // query: this.otherQuery
          });
        } catch (error) {
          this.loading = false;
        }
      } else {
        return false;
      }
    });
  }
  getOtherQuery(query) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== 'redirect') {
        acc[cur] = query[cur];
      }
      return acc;
    }, {});
  }
};
default_1 = __decorate([Component({
  name: 'Recover Password',
  components: {
    LangSelect
  }
})], default_1);
export default default_1;